<template>
  <div class="table" ref="table">
    <el-table
      @row-click="onSelect"
      header-row-class-name="header"
      style="width: 100% !important"
      v-bind="{ ...$attrs }"
      v-on="$listeners"
      :row-class-name="tableRowClassName"
    >
      <slot v-bind="$slots"></slot>
      <!-- <template #empty>NO Data</template> -->
    </el-table>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  mounted() {
    if (window.ResizeObserver) {
      let resizeObserver = new window.ResizeObserver(() => {
        this.setHeight();
      });

      resizeObserver.observe(this.$refs.table.querySelector(".el-table "));
    } else {
      window.onresize = () => {
        this.setHeight();
      };
    }
    this.$nextTick(() => {
      this.setHeight();
    });
  },
  methods: {
    setHeight() {
      if (this.$refs.table && this.$refs.table.querySelector(".el-table ")) {
        let ele = this.$refs.table.querySelector(".el-table ");
        this.$refs.table.style = "height:" + ele.offsetHeight + "px";
      }
      this.$emit("resize");
    },
    onSelect(item) {
      this.$emit("select", item);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 != 0) {
        return "row_bg";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 700px;
.table {
  width: 100%;
  flex: 1;
  position: relative;
  // border-left: 1px solid #e5e5e5;
  // border-right: 1px solid #e5e5e5;
  // border-top: 1px solid #e5e5e5;
  .el-table {
    position: absolute;
    flex: 1;
  }

  ::v-deep .el-table__body {
    width: 100% !important;
  }
  ::v-deep .el-table .el-table__cell {
    padding: 7px 0;
  }
  ::v-deep .has-gutter thead {
    line-height: 1;
  }
  ::v-deep .el-table th.el-table__cell {
    background-color: rgba($color: #d8d8d8, $alpha: 0);
    font-size: 12px;
    font-weight: 300 !important;
    color: #3d3d3d;
    text-transform: uppercase;
  }
  ::v-deep .el-table tbody .cell {
    font-size: 12px;
    font-weight: 300;
    white-space: normal;
    word-break: break-word;
    overflow: unset;
    @media screen and (max-width: $max-width) {
      text-overflow: unset;
      word-break: unset;

      .table_cell_1 {
        text-overflow: unset;
        word-break: unset;
        // overflow: unset;
      }
    }

    // @media screen and (max-width: $max-width) {
    //   font-size: 10px;
    // }
    // white-space: nowrap;
    // color: #747474;
    // font-family: SF-Pro-Display-Bold;
  }
  ::v-deep
    .el-table--enable-row-hover
    .el-table__body
    tr:hover
    > td.el-table__cell {
    background-color: #f5f7fa;
    position: static;
    .cell {
      overflow: unset;
      .table_cell_1 {
        overflow: unset;
      }
      @media screen and (max-width: $max-width) {
        text-overflow: unset;
        word-break: unset;
        .table_cell_1 {
          text-overflow: unset;
          word-break: unset;
        }
      }
    }
  }
  ::v-deep .el-table th.el-table__cell > .cell {
    font-size: 12px;
    font-weight: 300;
    color: #747474;
    font-family: SF-Pro-Display-Bold;
  }
  ::v-deep .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid transparent;
    // border-bottom: 1px solid #e5e5e5;
  }
  ::v-deep .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #707070 !important;
  }
  ::v-deep .el-table .descending .sort-caret.descending {
    border-top-color: #707070 !important;
  }
  ::v-deep .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px dashed #9b9b9b;
  }
  ::v-deep .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: transparent;
  }
}
</style>
